import Vue from 'vue/dist/vue.esm';
import ProcessNote from './components/ProcessNote';
import 'whatwg-fetch';

Vue.config.productionTip = false;

if (document.querySelector('#processNoteApp')) {
    new Vue({
        render: h => h(ProcessNote),
    }).$mount('#processNoteApp');
}
